// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface INewbuildingBrokerSchema {
  /** Какой флоу взаимодействия с брокерами доступен пользователю **/
  availableBrokerFlow?: EAvailableBrokerFlow | null;
  /** Брокер доступен для пользователя. Deprecated, используй available_broker_flow **/
  isAvailable: boolean;
  /** Пользователь прошел регистрацию в программе вознаграждений **/
  isPartnerRewardsRegistered: boolean;
  /** Ссылка для перехода в случае флоу брокера с вознаграждением **/
  partnerRewardsFlowUrl: string;
}
export enum EAvailableBrokerFlow {
  /** Обычный флоу взаимодействия с брокерами **/
  'Regular' = 'regular',
  /** Флоу, в котором Циан выплачивает вознаграждения риелторам **/
  'WithPartnerRewards' = 'withPartnerRewards',
}
